let Callbacks	=	{};

const Common	=	new (function ($) {
	var Load		=	new XMLHttpRequest();
	
	this.escapeSelector	=	function (value){
		value	=	value +"";

		return value.replace(/[ !"#$%&'()*+,.\/:;<=>?@\[\\\]^`{|}~]/g, '\\$&');
	}

	this.htmlentities	=	function (value) {
		return String(value).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
	}

	this.sanitize	=	function (values) {
		if(typeof values == "string") {
			return this.htmlentities(values);
		}

		for(var key in values) {
			if(typeof values[key] === "object") {
				values[key]	=	arguments.callee(values[key]);
			}
			else {
				values[key]	=	this.htmlentities(values[key]);
			}
		}

		return values;
	}

	this.comma	=	function (value) {
		return String(value).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
	}
});

$(function () {
	let Load	=	new XMLHttpRequest();
	let Change	=	new XMLHttpRequest();

	//画面遷移
	$("body").on("click", "a.load", function (e) {
		e.preventDefault();
		
		load.call(this);
	});
	
	$("#Navi .menu").on("click", function (e) {
		$("#Navi .menu").next(".subMenus").stop().slideUp();
		$(this).next(".subMenus").stop().slideDown();
	});

	function load(noState) {
		let url			=	$(this).attr("href");
		let $target		=	$(this);
		let $content	=	$('<div class="content"></div>');

		$("#Contents").html($content);
		$("#Warning .message").stop().hide();
		$("#Loading").stop().fadeIn();

		Load.abort();
		Load	=	$.ajax({
			url			:	url,
			method		:	"get",
			dataType	:	"html",
			timeout		:	30000,
		}).done(function (result) {
			$("#Loading").fadeOut();

			$("html, body").animate({scrollTop : 0});

			$content.fadeOut(function () {
				$content
					.html($(result).html());

				$content
					.show()
					.trigger("complete")
					.hide()
					.fadeIn();

				if(!noState && URL != url) {
					history.pushState(null, null, url);

					URL	=	url;
				}
			});
		}).fail(function (xhr, status) {
			if(status == "abort") {
				$("#Loading").stop().hide();
				$("#Warning .message").stop().show();
			}
			else {
				$("#Loading").stop().fadeOut();
				$content.stop().fadeOut(function () {
					$("#Warning .message")
						.text("通信エラー")
						.stop()
						.fadeIn();
				
					if(!noState && URL != url) {
						history.pushState(null, null, url);

						URL	=	url;
					}

					document.title	=	document.title.replace(/^(.*)\|/, "通信エラー" +"|");
				});
			}
		}).always(function () {
			$("#Navi .subMenus").stop().slideUp();
			$("#Navi .subMenus").find(".active").removeClass("active");
			
			if(url.match(/^[^\/]+\/\/[^\/]+\/(.*)?/)) {
				let $target	=	$("#Navi .subMenus a[href="+ Common.escapeSelector(url) +"]");

				$target.closest(".subMenus").stop().slideDown();
				$target.closest("li").addClass("active");
			}
		});
	};

	//ポップアップ
	$("body").on("click", "a.popup", function (e) {
		e.preventDefault();

		let $target	=	$(this);
		let data	=	"";
		
		if($target.hasClass("post")) {
			data	=	$target.closest("form").serialize();
		}

		popup.call(this, data);
	});

	function popup(data) {
		var $link	=	$(this);
		var url		=	$(this).attr("href");
		var loading	=	'<div class="loading"></div><div class="wrapper">&nbsp;</div><div class="close button material-icons">close</div>';
		var width	=	$("#Wrapper").width();

		$("#Overlay").append($("#Overlay").attr("data-template"));

		var $content	=	$("#Overlay .content:last");

		$content.closest(".layer").prev(".layer").find(".wrapper").animate({opacity : 0.3});
		$content.closest(".layer").prev(".layer").prev(".layer").find(".wrapper").animate({opacity : 0});

		$("#Wrapper").css({
			position	:	"fixed",
			top			:	$(window).scrollTop() * (-1),
		});

		$("html, body").css({
			overflow	:	"hidden",
		});

		$("#Wrapper, #Header").css({"padding-right" : $("body").width() - width});

		$content.html(loading);
		$content.css({
			height	:	"auto",
			width	:	"auto",
		});

		var params	=	{
			opacity		:	1,
		};

		$("#Overlay").stop().css({visibility : "visible"}).animate(params, function () {
			loadPopup(url, $link, $content, data);
		});
	}

	function loadPopup(url, $link, $content, data) {
		Load.abort();
		Load	=	$.ajax({
			url			:	url,
			method		:	(data)?	"post"	:	"get",
			data		:	data,
			dataType	:	"html",
			timeout		:	30000,
		}).done(function (result) {
			var minWidth	=	$content.innerWidth();
			var minHeight	=	$content.innerHeight();
			var width		=	$link.attr("data-width");
			var height		=	$link.attr("data-height");

			$("#Overlay").css({overflow : "hidden"});
			$content.prev(".scale").html(result);
			$("#Overlay").trigger("preload");
			
			var maxWidth	=	width || $content.prev(".scale").innerWidth();
			var maxHeight	=	height || $content.prev(".scale").innerHeight();

			$("#Overlay").css({overflow : ""});
			$content.prev(".scale").html("");

			$content.animate({
				height		:	maxHeight,
				width		:	maxWidth,
			}, {
				step		:	function () {
					$("#Overlay").trigger("reflesh");
				},
				complete	:	function () {
					$("#Overlay .layer:last .content .loading").fadeOut(function () {
						$("#Overlay .layer:last .content .wrapper")
							.stop()
							.css({visibility: "hidden"})
							.html(result)
							.fadeOut(0)
							.fadeIn()
							.css({visibility: "visible"});

						$content
							.css({
								height	:	height || "auto",
								width	:	width || "auto",
							})
							.trigger("complete");
							
						$("#Overlay").trigger("complete");

						$content.find("*[data-trigger]").each(function () {
							$(this).trigger($(this).attr("data-trigger"));
						});
					});
				}
			});
		}).fail(function (xhr, status) {
			if(status == "abort") {
				$("#Loading").stop().hide();
				$("#Warning .message").stop().show();
			}
			else {
				$("#Overlay .layer:last .content .loading").hide();
				$("#Overlay .layer:last .content .wrapper")
					.html('<span class="unconnect">通信エラー</span>')
					.stop()
					.fadeIn();
			}
		});
	};

	$("input[data-href]").on("click", function (e) {
		e.preventDefault();

		location.href	=	$(this).attr("data-href");
	});

	//フォーム
	$("body").on("click", "[data-action=fileChoice]", function (e) {
		let $target	=	$(this);
		let $multi	=	$target.closest("#Form .files.multi");
		
		$target.closest(".content").find("[data-target=fileTarget]").removeAttr("data-target");
		$target.attr("data-target", "fileTarget");

		$target.on("add", function () {
			if($multi.find(".item .nothing").length == 0 && $multi.attr("data-limit") > $multi.find(".item").length) {
				$multi.append($multi.attr("data-nothing"));
			}
		});
	});

	$("body").on("click", "[data-action=fileDelete]", function (e) {
		e.preventDefault();
		e.stopPropagation();
		
		let $target	=	$(this).closest(".file");
		let $multi	=	$target.closest("#Form .files.multi");

		if($multi.length != 0) {
			$target.closest(".item").remove();

			if($multi.find(".item .nothing").length == 0 && $multi.attr("data-limit") > $multi.find(".item").length) {
				$multi.append($multi.attr("data-nothing"));
			}
		}
		else {
			$target.html($target.attr("data-nothing"));
		}
	});
	
	$("body").on("change first", "select, input[type=radio], input[type=checkbox]", function (e) {
		let duration	=	(e.type == "first")?	0	:	"normal";

		let supplies	=	[];
		let exceptions	=	[];

		$("[data-supply]").each(function () {
			let $item	=	$(this)
			let list	=	$item.attr("data-supply").split(",");

			for(let i in list) {
				exceptions.push(list[i]);

				if($item.is(":checked") || $item.is(":selected")) {
					supplies.push(list[i]);
				}
			}
		});

		for(let i in exceptions) {
			$("[data-fieldID=\""+ Common.escapeSelector(exceptions[i]) +"\"]").stop().slideUp({
				duration	:	duration,
				complete	:	function () {
					$(this).find("input, textarea, select").attr("disabled", true);
				}
			});
		}

		for(let i in supplies) {
			$("[data-fieldID="+ Common.escapeSelector(supplies[i]) +"]").stop().slideDown({
				duration	:	duration,
				complete	:	function () {
					$(this).find("input, textarea, select").attr("disabled", false);
				}
			});
		}
	});

	$("#Header .menu").on("click", function () {
		let $target	=	$(this);

		$target.toggleClass("active");

		if($target.hasClass("active")) {
			$("#Header .menus .inner").stop().slideDown();
		}
		else {
			$("#Header .menus .inner").stop().slideUp();
		}
	});
	
	$("body").on("click", ".addition .add", function (e) {
		let $target	=	$(this);
		let $changes	=	$target.closest(".changes");
		let limit	=	$changes.attr("data-limit") || "0";
		
		if(limit == "0" || $changes.find(".change").length <= limit) {
			$target.closest(".change").after($($changes.attr("data-template")));
		}
	});
	
	$("body").on("click", ".addition .remove", function (e) {
		let $target	=	$(this);
		let $changes	=	$target.closest(".changes");
		
		$target.closest(".change").remove();

		if($changes.find(".change").length == 0) {
			$changes.append($($changes.attr("data-template")));
		}
	});

	$("#Overlay").on("preload", function () {
		$(this).find(".layer:last").find("select, input[type=radio], input[type=checkbox]").filter(":first").trigger("first");
	});

	$("#Overlay").on("complete", function () {
		$(this).find("select, input[type=radio], input[type=checkbox]").filter(":first").trigger("first");
	});

	//オーバーレイ
	$("#Overlay").on("click", ".close", function (e) {
		if($(e.target).hasClass("close")) {
			if($("#Overlay .layer").length <= 1) {
				$("#Overlay").animate({opacity : 0}, function () {
					$(this).html("").css({
						visibility	:	"hidden",
					});

					$("#Wrapper").css({
						position	:	"",
					});

					$("html, body").css({
						overflow	:	"",
					});

					$("#Wrapper, #Header").css({
						paddingRight	:	"",
					});
					
					$("html, body").scrollTop($("#Wrapper").css("top").replace(/[^\d]/g, ""));
				});
			}
			else {
				var $layer	=	$(this).closest(".layer");

				$layer.fadeOut(function () {
					$(this).remove();
				});

				$layer.prev(".layer").find(".wrapper").animate({opacity : 1});
				$layer.prev(".layer").prev(".layer").find(".wrapper").animate({opacity : 0.3});
			}
		}
	});

	$(window).on("resize reflesh", function () {
		$("#Overlay .layer").each(function () {
			let $layer	=	$(this)

			if($("#Overlay").innerHeight() < $layer.find(".content").innerHeight() + 40) {
				$layer.css({
					alignItems	:	"flex-start",
				});
			}
			else {
				$layer.css({
					alignItems	:	"center",
				});
			}
		});
	});

	//URL補正
	$(window).on("popstate", function () {
		let url		=	encodeURI(location.href);
		
		$("#Overlay .close").trigger("click");
		
		if(location.pathname == '/admin/') {
			$("#Contents .content").hide();
			load.call($("#Navi a[href="+ Common.escapeSelector("/admin/dashboard/") +"]"), true);
		}
		else if($("#Navi .subMenus a[href="+ Common.escapeSelector(location.pathname) +"]").length == 1) {
			$("#Contents .content").hide();
			load.call($("#Navi .subMenus a[href="+ Common.escapeSelector(location.pathname) +"]"), true);
		}
		else if(location.pathname == '/admin/login') {
			;
		}
		else if(location.pathname.match(/^\/admin\/[A-Za-z0-9\/]+$/)){
			let $link	=	$('<a href="'+ url +'"></a>');
			
			$("#Contents .content").hide();
			load.call($link, true);
		}

		URL	=	url;
	}).trigger("popstate");
});